
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {baseUrl, limit, getDateWithDay} from "../../comman/config";
import { can } from "../../comman/permissions";
import { useNavigate, Link } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { DateSessionFilter } from '../../components/Filter/DateSessionFilter';
import { EventDateSessionFilter } from '../../components/Filter/EventDateSessionFilter';
import * as XLSX from 'xlsx';


function List() {
    const today = new Date().toISOString().split("T")[0];
    const [mealList, setMealList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [methodList, setMethodList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [session, setSession] = useState("");

    const navigate = useNavigate();
    // role 0 = superadmin, 1 = admin -- the same pair every other screen treats as unrestricted.
    const role = String(localStorage.getItem('userRole'));
    // Which buttons this user gets is Role Master's call now, not a role number's -- see
    // comman/permissions.js. `role` is still read because it is what the delete and enable
    // endpoints are told to check against.
    const canDisable = can('disable');
    const canActivate = can('active');
    const canDelete = can('delete');
    // if(role != 1){
    //     navigate("/login");
    // }
    useEffect(() => {
        getMeal();
        getMethodList();
    }, []);

    // useEffect(() => {
    //     let filterelist;
    //     if(searchQuery){
    //         filterelist = mealList.filter(item => {
    //             return item.eng_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //                    item.item_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //                    item.session.toLowerCase().includes(searchQuery.toLowerCase()) ||
    //                    getDateWithDay(item.date).toLowerCase().includes(searchQuery.toLowerCase());
    //         });
    //     } else{
    //         filterelist = mealList;
    //     }  
    //     setFilteredList(filterelist);
    // }, [searchQuery]);

    useEffect(()=>{
        let filterList = mealList;

        if (fromDate && toDate) {
            const from = new Date(fromDate);
            const to = new Date(toDate);
    
            filterList = filterList.filter((item) => {
                const itemDate = new Date(item.date); // Ensure item.date is a Date object
                return itemDate >= from && itemDate <= to;
            });

        }

        if (session && session.length > 0) {
            const selectedSessionIds = session.map((s) => s.value); // Extract session IDs from multi-select
            filterList = filterList.filter((item) => selectedSessionIds.includes(item.session_id));
        }

        setFilteredList(filterList);
    },[fromDate,toDate,session,mealList])

    const filterConditions = () => {
        const conditions = [];
        if (fromDate && toDate) {
            if (fromDate === toDate) {
                conditions.push(`m.date = '${fromDate}'`);
            } else {
                conditions.push(`(m.date >= '${fromDate}' AND m.date <= '${toDate}')`);
            }
        }
        if (session && session.length > 0) {
            const sessionIds = session.map(s => s.value);
            conditions.push(`m.session IN (${sessionIds.join(',')})`);
        }
        return conditions.length > 0 ? conditions.join(' AND ') : '1';
    }

    const getMeal = async () => {
        // console.log(page);
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/meal_master/list?page=${page}&limit=${limit}`, {
           
        });
        setPopupOpen(false);
        setMealList(response.data.data);
        setFilteredList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const getMethodList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=method_master&condition=status=1`);
        setMethodList(response.data.data);
    }

    const handelFilterChange= (e) => {
        const { value } = e.target;
        setSearchQuery(value);
    };

    const deleteMeal = async (item) => {
        const shouldDelete = window.confirm("Are you sure you want to disable this meal?");
        if (shouldDelete) {
            try {
                await axios.post(`${baseUrl}/meal_master/delete`, {data:item});
                window.location.reload();
            } catch (error) {
                console.log(error);
            }
        }
    };

    // Enable puts a disabled session back; only an admin may. The backend checks the role too --
    // hiding the button is presentation, not permission.
    const enableSession = async (item) => {
        if (!window.confirm("Enable this session?")) return;
        try {
            await axios.post(`${baseUrl}/meal_master/session_status`, {
                date: item.date, session_id: item.session_id, status: 1, role,
            });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not enable the session.');
        }
    };

    // Delete removes the meals outright, unlike Disable which is recoverable. Superadmin only, and
    // worded so the difference is unmistakable at the point of clicking.
    const deleteSession = async (item) => {
        if (!window.confirm(`Permanently DELETE every meal for ${item.date} ${item.session}? Disable is reversible; this is not.`)) return;
        try {
            await axios.post(`${baseUrl}/meal_master/session_delete`, {
                date: item.date, session_id: item.session_id, role,
            });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not delete the session.');
        }
    };

    const editMeal = async (id) => {
        navigate(`/meal_master/edit/${btoa(id)}`, { state: mealList.filter(item => item.id == id) });
    }

    // const measurementName =  (ids) => {
    //     const idArray = (ids || '').split(",").map(Number);// Convert string to array of numbers
    // const names = idArray.map(id => {
    //     const method = methodList.find(method => method.id === id);
    //     return method ? method.name : ''; // Return method name if found, or an empty string otherwise
    // });
    // return names.join(", ");
    // }

    const exportToExcel = async () => {
        try {
            //setLoading(true)
            const conditionString = filterConditions();
            console.log("Condition:", conditionString);
            const response = await axios.get(`${baseUrl}/meal_master/export?condition=${conditionString}`)
            console.log(response.data);
            if (response.data.items.length >= 1) {
                const data = response.data.items.map(item => ({
                    Date: getDateWithDay(item.date),
                    Session: item.session,
                    Event: item?.event_deail?.event_name ?? "-",
                }));

                const worksheet = XLSX.utils.json_to_sheet(data);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Meal Master");

                XLSX.writeFile(workbook, "Meal_Master.xlsx");
            } else {
                alert("Export is only available when there is one or more data item.");
            }
        } catch (error) {
            console.error('Error exporting data:', error);
        } finally {
            //setLoading(false)
        }

    };
   
    const handelEventDateSessionFilterChange = async (fromDate,toDate,session) => {
        setFromDate(fromDate)
        setToDate(toDate)
        setSession(session);
    };


    return (
        <div className="p-4">
            {/* Renders the toast a Save on the edit form raised on its way here. Toasts live in
                one store shared across the app, but only a mounted Toaster draws them, and the
                edit form's own goes when the form does. */}
            <Toaster position="top-center" reverseOrder={false} />
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Meal Master List</h1>
                <div>
                    <button
                        onClick={exportToExcel}
                        className={`px-4 py-2 bg-green-500 text-white rounded-md mr-4 hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-200 ${filteredList.length >= 1 ? '' : 'opacity-50 cursor-not-allowed'}`}
                        disabled={filteredList.length === 0}
                    >
                        Export
                    </button>
                    <Link to="/meal_master/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Meal</button>
                    </Link>
                </div>
            </div>
            {/* The filter is deliberately outside the table's scroll box. overflow-x-auto
                clips on both axes, so a react-select menu opened inside it cannot escape --
                the event list was trapped in the filter strip and put a scrollbar there
                instead of dropping over the page. Every other screen that uses this filter
                keeps it outside the scroll container for the same reason. */}
            <div className="relative shadow-md sm:rounded-lg">
                <EventDateSessionFilter handleFilterChange={handelEventDateSessionFilterChange} />
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                {/* <div className="pb-4 flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center justify-between">
                    <label htmlFor="table-search" className="sr-only">Search</label>
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                            <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
                        </div>
                        <input type="text" value={searchQuery} onChange={handelFilterChange} id="table-search" className="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-80 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for items" />
                    </div>
                </div> */}

                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">Date</th>
                            <th scope="col" className="px-6 py-3">Session</th>
                            {/* <th scope="col" className="px-6 py-3">Item</th>                            <th scope="col" className="px-6 py-3">Measurement</th> */}
                            <th scope="col" className="px-6 py-3">Event</th>
                            <th scope="col" className="px-6 py-3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {filteredList.map((item) => (
                        <tr key={item.id} className={`border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 ${Number(item.status) === 1 ? 'bg-white dark:bg-gray-800' : 'bg-gray-100 text-gray-400 dark:bg-gray-900'}`}>
                            <td className="px-6 py-4">{getDateWithDay(item.date)}</td>
                            <td className="px-6 py-4">{item.session}</td>
                            {/* <td className="px-6 py-4">{item.item_name} ({item.eng_name})</td>
                            <td className="px-6 py-4">{measurementName(item.measurements)}</td> */}
                            <td className="px-6 py-4">{item?.event_deail?.event_name ?? "-"}</td>
                            {/* Named buttons rather than a pencil and a cross. The cross in
                                particular read as "delete" while it disables the session, which is
                                a different and recoverable thing. */}
                            <td className="px-6 py-4">
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        onClick={() => editMeal(item.id)}
                                        className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">
                                        Edit
                                    </button>
                                    {Number(item.status) === 1 ? (
                                        <button
                                            type="button"
                                            onClick={() => deleteMeal(item)}
                                            className="px-3 py-1 text-sm bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200">
                                            Disable
                                        </button>
                                    ) : (
                                        canActivate && (
                                        <button
                                            type="button"
                                            onClick={() => enableSession(item)}
                                            className="px-3 py-1 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring focus:ring-green-200">
                                            Enable
                                        </button>
                                        )
                                    )}
                                    {canDelete && (
                                        <button
                                            type="button"
                                            onClick={() => deleteSession(item)}
                                            className="px-3 py-1 text-sm bg-red-700 text-white rounded-md hover:bg-red-800 focus:outline-none focus:ring focus:ring-red-300">
                                            Delete
                                        </button>
                                    )}
                                </div>
                            </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
        </div>
  );
}

export default List;